/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TableTagRelationConnectionRepresentationFromJSON, TableTagRelationConnectionRepresentationToJSON, } from './';
export function TableTagRelationRepresentationFromJSON(json) {
    return TableTagRelationRepresentationFromJSONTyped(json, false);
}
export function TableTagRelationRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        description: json['description'],
        tableTagId: json['tableTagId'],
        connectedTableTagId: json['connectedTableTagId'],
        connections: json['connections'].map(TableTagRelationConnectionRepresentationFromJSON),
    };
}
export function TableTagRelationRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        description: value.description,
        tableTagId: value.tableTagId,
        connectedTableTagId: value.connectedTableTagId,
        connections: value.connections.map(TableTagRelationConnectionRepresentationToJSON),
    };
}
